import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Box,
  Button
} from '@mui/material';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast, Toaster } from 'react-hot-toast';
import CloseIcon from '@mui/icons-material/Close';
import { Plus, X } from 'lucide-react';

const EditAlertModal = ({ open, onClose, alert }) => {
    const [loading, setLoading] = useState(false);
    const [receiveTeamsAlerts, setReceiveTeamsAlerts] = useState(alert.alert_type === "TEAMS" ? true : false);
    const [receiveEmailAlerts, setReceiveEmailAlerts] = useState(alert.alert_type === "EMAIL" ? true : false);
    const [emails, setEmails] = useState(alert.alert_type === "EMAIL" ? JSON.parse(alert.alert_config).email?.split(", ") : ['']);
    const [emailErrors, setEmailErrors] = useState(['']);
    const [alertType, setAlertType] = useState(alert.alert_type || "");
    const [alertTeamConfig, setAlertTeamConfig] = useState({
        channel_name: '',
        webhook_link: '',
      });
      const [alertEmailConfig, setAlertEmailConfig] = useState({
        email: '',
        alert_url: process.env.REACT_APP_EMAIL_ALERT_URL
      });
    
    const [formData, setFormData] = useState({
          alert_id: alert.alert_id,
          data_asset_id: alert.data_asset_id,
          alert_type: alert.alert_type,
          alert_config: JSON.parse(alert.alert_config),
          is_active: alert.is_active,
          last_modified_by: localStorage.getItem('userName') || 'user',
        });

    useEffect(() => {
        const alertType = receiveTeamsAlerts ? "TEAMS" : "EMAIL";
        const alertConfig = alertType === "TEAMS" ? alertTeamConfig : alertEmailConfig;
        
        setAlertType(alertType);
        setFormData(prev => ({ ...prev, alert_type: alertType, alert_config: JSON.stringify(alertConfig) }));
        console.log("form data", formData);
    }, [receiveEmailAlerts, receiveTeamsAlerts, alertTeamConfig, alertEmailConfig, emails]);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleEmailChange = (index, value) => {
        const newEmails = [...emails];
        const newErrors = [...emailErrors];
    
        newEmails[index] = value;
        newErrors[index] = value === '' ? '' : (!validateEmail(value) ? 'Invalid email format' : '');
    
        setEmails(newEmails);
        alertEmailConfig.email = newEmails.join(', ');
        setEmailErrors(newErrors);
    };

    const addEmail = () => {
        if (emails.length < 5) {
            setEmails([...emails, '']);
            setEmailErrors([...emailErrors, '']);
        }
    };

  const removeEmail = (index) => {
    if (emails.length > 1) {
      const newEmails = emails.filter((_, i) => i !== index);
      const newErrors = emailErrors.filter((_, i) => i !== index);
      setEmails(newEmails);
      alertEmailConfig.email = newEmails.join(', ');
      setEmailErrors(newErrors);
    }
  };

  const setTeamsMode = () =>{
    setReceiveTeamsAlerts(true);
    setReceiveEmailAlerts(false);
  }

  const setEmailMode = () =>{
    setReceiveTeamsAlerts(false);
    setReceiveEmailAlerts(true);
  }

  const handleInputChange = (field, value) => {
    setAlertTeamConfig(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    setLoading(true);
    if(receiveTeamsAlerts){
      setFormData(prev => ({
        ...prev,
        alert_config: JSON.stringify(alertTeamConfig),
      }));
    }else if(receiveEmailAlerts){
      setFormData(prev => ({
      ...prev,
      alert_config: JSON.stringify(alertEmailConfig),
    }));
    }
    axios.post(`${process.env.REACT_APP_API_URL}/alerts/update/${alert.alert_id}`, formData)
            .then(res => {
              toast.success('Alert configuration updated.');
              setReceiveEmailAlerts(false);
              setReceiveTeamsAlerts(false);
              setEmails(['']);
              setAlertTeamConfig(prev => ({
              ...prev, channel_name: "", webhook_link:""
              }));
              onClose();
            })
            .catch(() => {
              toast.error('Failed to update alert');
            })
            .finally(() => {
              setLoading(false);
            }
    );
  }

  const isAddButtonDisabled = () => {
    return emails.length >= 5 || emails.some(email => email === '' || !validateEmail(email));
  };

   const isSubmitButtonDisabled = () => {
    if(alertType === "TEAMS")
      return alertTeamConfig.channel_name === '' || alertTeamConfig.webhook_link === '';
    return emails.some(email => email === '' || !validateEmail(email));
  };

    return(
        <>
        <Toaster position="top-right" />
        <Dialog open={open} onClose={onClose} maxWidth="md"  fullWidth >
            <DialogTitle sx={{ borderBottom: 1, borderColor: 'divider', pb: 2 }}>
                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box>
                        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>Edit Alert</Typography>
                    </Box>
                    <IconButton onClick={onClose} size="small">
                        <CloseIcon />
                    </IconButton>
                 </Box>
            </DialogTitle>
            
            <DialogContent sx={{ py: 3, px: 0 }}>
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                    <table className="min-w-full">
                        <thead className="bg-[#0000a0]">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Setting</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Configuration</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            <tr className="hover:bg-gray-50 transition-colors">
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">Alert Type</td>
                              <td className="px-6 py-4 text-sm text-gray-700">
                                <div className="flex items-center space-x-4">
                                  <label className="flex items-center space-x-2 cursor-pointer">
                                  <input
                                    type="radio"
                                    name="alertMode"
                                    value="TEAMS"
                                    checked={receiveTeamsAlerts === true}
                                    onChange={() => setTeamsMode()}
                                    className="w-4 h-4 text-[#0000A0] border-gray-300 focus:ring-[#0000A0]"
                                  />
                                  <span className="text-gray-700">Teams</span>
                                  </label>
                                  <label className="flex items-center space-x-2 cursor-pointer">
                                    <input
                                      type="radio"
                                      name="alertMode"
                                      value="EMAIL"
                                      checked={receiveEmailAlerts === true}
                                      onChange={() => setEmailMode()}
                                      className="w-4 h-4 text-[#0000A0] border-gray-300 focus:ring-[#0000A0]"
                                    />
                                  <span className="text-gray-700">Email</span>
                                  </label>
                                </div>
                              </td>
                            </tr>
                {receiveEmailAlerts && (
                <tr className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">Email Addresses</td>
                    <td className="px-6 py-4 text-sm text-gray-700">
                        <div className="space-y-3">
                            <div className="text-sm text-gray-600 mb-2">
                                Enter email address (You can add up to 5 email addresses):
                            </div>
                                      
                            {/* Email Input Fields */}
                            <div className="space-y-2">
                                {emails.map((email, index) => (
                                <div key={index} className="flex items-center space-x-2">
                                    <div className="flex-1">
                                        <input
                                                type="email"
                                                value={email}
                                                onChange={(e) => handleEmailChange(index, e.target.value)}
                                                placeholder="Enter email address"
                                                className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm ${
                                                  emailErrors[index] ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                        />
                                        {emailErrors[index] && (
                                         <p className="text-red-500 text-xs mt-1">{emailErrors[index]}</p>
                                        )}
                                    </div>
                                    {emails.length > 1 && (
                                    <button onClick={() => removeEmail(index)}
                                        className="p-1 text-red-600 hover:text-red-800 transition-colors"
                                        title="Remove email">
                                        <X size={14} />
                                    </button>
                                    )}
                                </div>
                                ))}
                            </div>
                
                            {/* Add Another Email Button */}
                            <div className="flex items-center space-x-2">
                                <button
                                    onClick={addEmail}
                                    disabled={isAddButtonDisabled()}
                                    className={`flex items-center space-x-2 px-3 py-1 rounded text-sm font-medium transition-colors ${
                                    isAddButtonDisabled()
                                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#0000A0] text-white hover:bg-[#0000A0]'
                                    }`}
                                >
                                    <Plus size={14} />
                                    <span>Add another email</span>
                                </button>
                                {emails.length >= 5 && (
                                    <span className="text-xs text-gray-500">Maximum 5 email addresses reached</span>
                                )}
                            </div>
                        </div>
                    </td>
                </tr>
                )}
                {receiveTeamsAlerts && (
                <tr className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">Teams Configuration</td>
                    <td className="px-6 py-4 text-sm text-gray-700">
                        <div className="space-y-3">
                            <div className="text-sm text-gray-600 mb-2">Channel Name</div>
                                <div className="space-y-2">
                                    <input
                                        type="text"
                                        value={formData.alert_config.channel_name}
                                        onChange={e => handleInputChange('channel_name', e.target.value)}
                                        placeholder="Enter Channel name"
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                                      />
                                </div>
                
                            <div className="text-sm text-gray-600 mb-2">Webhook Link</div>
                                <div className="space-y-2">
                                    <input
                                        type="text"
                                        value={formData.alert_config.webhook_link}
                                        onChange={e => handleInputChange('webhook_link', e.target.value)}
                                        placeholder="Enter webhook link"
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                                      />
                                </div>
                            </div>
                    </td>
                </tr>          
                )}
                <tr className="hover:bg-gray-50 transition-colors items-center">
                    <td className="px-6 py-4 text-sm text-gray-700">
                        <button disabled={isSubmitButtonDisabled()}
                                className={`flex items-center space-x-2 px-3 py-1 rounded text-sm font-medium transition-colors ${
                                            isSubmitButtonDisabled()
                                              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                              : 'bg-[#0000A0] text-white hover:bg-[#0000A0]'
                                          }`}
                                onClick={() => handleSubmit()}
                                
                              >
                                 Update Alert
                        </button>
                    </td>
                </tr>
                        </tbody>
                    </table>
     </div>
    </DialogContent>
    </Dialog>
    </>
    )
}

export default EditAlertModal;